"use client";

import LegalPage from "@/components/legal/LegalPage";

export default function TermsAndConditions() {
  return (
    <LegalPage
      pageTitle="Terms and Conditions"
      subtitle="Please read these terms carefully"
      legalKey="terms_and_conditions"
    />
  );
}
